module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/sv-card-drag.41ae4e95e9c9fbe20be3.gif";